



















import { defineComponent, PropType } from '@vue/composition-api'
import { TranslateResult } from 'vue-i18n'
import { TopUpDeal } from '~/utils/interfaces/topup.interface'
import Dialog from '../Dialog.vue'
import TextButton from '../TextButton.vue'
import DealCard from './DealCard.vue'

export default defineComponent({
  components: { Dialog, TextButton, DealCard },
  props: {
    deals: Array as PropType<TopUpDeal[]>,
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      model: this.value,
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    promotionText(): TranslateResult {
      if (!this.deals?.length) return ''
      return this.$t('topup_alert')
    },
  },
  watch: {
    value(v: boolean) {
      this.model = v
    },
    model(v: boolean) {
      this.$emit('input', v)
    },
  },
})
